"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const API_KEYS = {
    "mondaine-germany": process.env.MONDAINE_GERMANY_ACCESS_TOKEN_STOREFRONT,
    "mondaine-switzerland": process.env.MONDAINE_SWITZERLAND_ACCESS_TOKEN_STOREFRONT,
    "mondaine-uk": process.env.MONDAINE_UK_ACCESS_TOKEN_STOREFRONT,
    mondaine: process.env.MONDAINE_USA_ACCESS_TOKEN_STOREFRONT,
    "stage-mondaine": process.env.MONDAINE_STAGE_ACCESS_TOKEN_STOREFRONT,
    "luminox-germany": process.env.LUMINOX_GERMANY_ACCESS_TOKEN_STOREFRONT,
    "luminox-switzerland": process.env.LUMINOX_SWITZERLAND_ACCESS_TOKEN_STOREFRONT,
    "luminox-uk": process.env.LUMINOX_UK_ACCESS_TOKEN_STOREFRONT,
    luminoxusa: process.env.LUMINOX_USA_ACCESS_TOKEN_STOREFRONT,
    "stage-luminox": process.env.LUMINOX_STAGE_ACCESS_TOKEN_STOREFRONT,
    // "mwatch-switzerland": process.env.MWATCH_ACCESS_TOKEN,
};
function localize() {
    const pathSegments = window.location.pathname.split("/").filter(Boolean);
    const output = pathSegments[0] || "home";
    return output;
}
function returnedData(data, prodSku) {
    return data.find((item) => {
        var _a, _b;
        const variant = (_b = (_a = item.variants) === null || _a === void 0 ? void 0 : _a.nodes) === null || _b === void 0 ? void 0 : _b[0];
        return variant && variant.sku === prodSku;
    });
}
function fetchProducts() {
    return __awaiter(this, void 0, void 0, function* () {
        let allProducts = [];
        let cursor = null;
        let hasNextPage = false;
        const extractedJson = JSON.parse(localStorage.getItem("manualsData") || "");
        const manualsDataStoreName = extractedJson === null || extractedJson === void 0 ? void 0 : extractedJson.storeName;
        const STOREFRONT_API_URL = `https://${manualsDataStoreName}.myshopify.com/api/2024-01/graphql.json`;
        const query = `
            query Products($cursor: String) {
              products(first: 250, after: $cursor) {
                pageInfo { hasNextPage endCursor }
                nodes {
                  id
                  variants(first: 1) { nodes { sku } }
                  title
                  images(first: 1) { nodes { src } }
                }
              }
            }
          `;
        try {
            do {
                const headers = {
                    "Content-Type": "application/json",
                    "X-Shopify-Storefront-Access-Token": API_KEYS[manualsDataStoreName] || "",
                };
                const body = JSON.stringify({ query, variables: { cursor } });
                const response = yield fetch(STOREFRONT_API_URL, {
                    method: "POST",
                    headers,
                    body,
                });
                if (!response.ok) {
                    const text = yield response.text();
                    return new Error(`HTTP ${response.status}: ${text}`);
                }
                const { data } = yield response.json();
                if (data) {
                    allProducts.push(...data.products.nodes);
                    hasNextPage = data.products.pageInfo.hasNextPage;
                    cursor = data.products.pageInfo.endCursor;
                }
            } while (hasNextPage);
        }
        catch (error) {
            console.error("Error fetching products: ", error);
        }
        return allProducts;
    });
}
function onLoad() {
    return __awaiter(this, void 0, void 0, function* () {
        const isManualsPage = document.querySelector("#manuals-content");
        if (isManualsPage) {
            const manualsData = localStorage.getItem("manualsData");
            if (manualsData) {
                const mappedProduct = productManualsList(JSON.parse(manualsData));
                const allProducts = yield fetchProducts();
                localStorage.setItem("picturesData", JSON.stringify(allProducts));
                const tableBody = document.getElementById("manuals-content");
                if (tableBody) {
                    populateTable(tableBody, mappedProduct);
                }
                const searchBar = document.getElementById("searchBar");
                if (searchBar) {
                    searchBar.addEventListener("input", debounceSearchInput);
                    filterTableRows(true);
                    const resetButton = document.getElementById("resetFilter");
                    if (resetButton) {
                        resetButton.addEventListener("click", () => {
                            searchBar.value = "";
                            const newUrl = new URL(window.location.href);
                            newUrl.searchParams.delete("manuals-search");
                            window.history.replaceState({}, "", newUrl.toString());
                            filterTableRows();
                        });
                    }
                }
            }
        }
    });
}
function productManualsList(manualsData) {
    const productDtoList = manualsData.data.flatMap(({ manual, link, products }) => products.map(({ product, productCatalogDisplay, videoUrls, englishDescriptions, germanDescriptions, barCode, }) => ({
        product,
        videoUrls,
        englishDescriptions,
        germanDescriptions,
        barCode,
        manuals: [{ manual, link, addtitionalInfo: productCatalogDisplay }],
    })));
    const consolidatedResult = Object.values(productDtoList.reduce((acc, { product, manuals, videoUrls, englishDescriptions, germanDescriptions, barCode, }) => {
        if (!acc[product]) {
            acc[product] = {
                product,
                videoUrls,
                englishDescriptions,
                germanDescriptions,
                barCode,
                manuals: [],
            };
        }
        acc[product].manuals.push(...manuals);
        return acc;
    }, {}));
    return consolidatedResult;
}
function populateTable(tableBody, products) {
    tableBody.innerHTML = "";
    const tableElement = document.getElementById("table-content");
    const initialData = localStorage.getItem("picturesData") || "";
    const picturesData = initialData ? JSON.parse(initialData) : {};
    products.forEach((item) => {
        var _a, _b, _c;
        const { product, manuals, videoUrls, englishDescriptions, germanDescriptions, barCode, } = item;
        let imagesData;
        if (picturesData) {
            imagesData = returnedData(picturesData, product);
        }
        const row = document.createElement("tr");
        row.id =
            `${product} ${(imagesData === null || imagesData === void 0 ? void 0 : imagesData.title) || ""} ${barCode || ""}`.toUpperCase();
        let videoHtml = "";
        if (videoUrls &&
            englishDescriptions &&
            germanDescriptions &&
            tableElement) {
            const language = tableElement.getAttribute("language");
            const splitedUrls = videoUrls.split("|");
            const splitedEnglishDescriptions = englishDescriptions.split("|");
            const splitedGermanDescriptions = germanDescriptions.split("|");
            // same number of videos that english and german descriptions
            if (splitedUrls.length === splitedEnglishDescriptions.length &&
                splitedEnglishDescriptions.length === splitedGermanDescriptions.length) {
                const combinedString = splitedUrls
                    .map((url, index) => {
                    const videoDescription = language === "de"
                        ? splitedGermanDescriptions[index]
                        : splitedEnglishDescriptions[index];
                    const isLastItem = index === splitedUrls.length - 1;
                    if (url !== "" && videoDescription !== "") {
                        return `
              <div  style="margin-bottom: ${isLastItem ? "0" : "7px"};">
                <a href='${url}' target='_blank' style='text:decoration: none;'>
                  <button class="play-button-block__inner manual-button" type="button" style="display: flex; align-items: center; justify-content: center">
                    <div class="play-button-block-left" style="height: 24px">
                      <span class="icon icon-new icon-play-arrow">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="12" cy="11.97" r="11.22" stroke="currentColor" stroke-width="1.45px"></circle>
                          <path d="M15.51 12 9.79 7.84v8.26z" fill="currentColor"></path>
                        </svg>
                      </span>
                    </div>
                    <div class="play-button-block-right manuals-text-description" style="height: 100%">${videoDescription}</div>
                  </button>
                </a>
              </div>
              `;
                    }
                })
                    .join("");
                videoHtml = combinedString;
            }
        }
        const manualsHTML = manuals.map((manual) => {
            const additionalInfo = manual.addtitionalInfo || "";
            return `<div class='manual-wrapper'> ${additionalInfo} <a target="_blank" href="${manual.link}">${manual.manual}</a></div>`;
        });
        const firstManul = manualsHTML[0] || "";
        const secondManul = manualsHTML[1] || "";
        const thirdManul = manualsHTML[2] || "";
        const englishDescription = englishDescriptions
            .split("|")[0]
            .replace(",", " ")
            .replace("|", " ");
        const germanDescription = germanDescriptions
            .split("|")[0]
            .replace(",", " ")
            .replace("|", " ");
        const discontinuedProduct = JSON.parse(localStorage.getItem("manualsData") || "{}").discontinuedProduct;
        row.innerHTML = `
    <td> <div class="archived-wrapper">
    <img class="archived-image" src="${((_c = (_b = (_a = imagesData === null || imagesData === void 0 ? void 0 : imagesData.images) === null || _a === void 0 ? void 0 : _a.nodes) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.src) || discontinuedProduct}" alt="${product}">
    <p>${product} - ${imagesData ? imagesData === null || imagesData === void 0 ? void 0 : imagesData.title : "Archive collection"}</p>
  </div>
    <td> ${firstManul}
     </td>
    <td>${secondManul}</td>
    <td>${thirdManul}</td>
    <td>${localize() === "en" ? englishDescription : germanDescription}</td>
    <td> ${videoHtml} </td>
`;
        tableBody.append(row);
    });
}
function filterTableRows(isPageLoad = false) {
    const searchBar = document.getElementById("searchBar");
    if (searchBar) {
        const urlParams = new URLSearchParams(window.location.search);
        const searchQuery = urlParams.get("manuals-search");
        if (searchQuery && isPageLoad) {
            searchBar.value = searchQuery;
        }
        const searchText = searchBar.value.trim().toUpperCase();
        if (searchText === "" && !isPageLoad) {
            const newUrl = new URL(window.location.href);
            newUrl.searchParams.delete("manuals-search");
            window.history.replaceState({}, "", newUrl.toString());
            const tableViewDiv = document.querySelector("#table-content");
            tableViewDiv.style.display = "none";
        }
        else if (searchText !== "") {
            const rows = document.querySelectorAll("#manuals-content tr");
            let isAnyRowVisible = false;
            rows.forEach((row) => {
                const rowID = row.id.toUpperCase();
                if (rowID.includes(searchText)) {
                    row.classList.remove("hidden");
                    isAnyRowVisible = true;
                }
                else {
                    row.classList.add("hidden");
                }
            });
            const noElementDiv = document.querySelector("#no-item");
            const tableViewDiv = document.querySelector("#table-content");
            if (noElementDiv && tableViewDiv) {
                if (!isAnyRowVisible) {
                    ;
                    noElementDiv.style.display = "";
                    tableViewDiv.style.display = "none";
                }
                else {
                    ;
                    noElementDiv.style.display = "none";
                    tableViewDiv.style.display = "";
                }
            }
            const newUrl = new URL(window.location.href);
            newUrl.searchParams.set("manuals-search", searchBar.value.trim());
            window.history.replaceState({}, "", newUrl.toString());
        }
    }
}
// Function to debounce the search input
let debounceTimer;
function debounceSearchInput() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(filterTableRows, 1000);
}
document.addEventListener("DOMContentLoaded", onLoad);
